module.exports = __webpack_public_path__ + "img/19.b87d10f8.svg";